import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

export function Debounce(delay: number = 300) {
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        const originalMethod = descriptor.value;
        const subjectKey = Symbol();
        descriptor.value = function (...args: any[]) {
            if (!this[subjectKey]) {
                this[subjectKey] = new Subject<any[]>();
                this[subjectKey]
                    .pipe(debounceTime(delay))
                    .subscribe((latestArgs: any[]) => originalMethod.apply(this, latestArgs));
            }
            this[subjectKey].next(args);
        };
        return descriptor;
    };
}
